import { ChangeEvent, FC } from 'react';
import { Box, Switch, Typography } from '@material-ui/core';
import { useStyles } from '../../styles';

interface Props {
    value: boolean;
    handleChange: (e: ChangeEvent) => void;
}
const PublicEventSwitch: FC<Props> = ({ value, handleChange }) => {
    const classes = useStyles();

    return (
        <Box display="flex" flexDirection="column" alignItems="center" className={classes.row}>
            <Typography className={classes.label}>Public Event (Show event in the marketplace)</Typography>
            <Switch
                checked={value}
                onChange={handleChange}
                color="primary"
                className={classes.switch}
                inputProps={{ name: 'public' }}
            />
        </Box>
    );
};

export default PublicEventSwitch;
